import { Link } from "react-router-dom";
import BaseCom from "../BaseCom";
import DataTable from "../DataTable";
import Icon from "../Icon";
import { SidebarGlobal } from "../Sidebar";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { Modal } from "react-bootstrap";
import { Pop } from "../PopModal";
import { qreq } from "../../shared/qrequest";

class WorkflowList extends BaseCom {

    async componentDidMount() {
        this.updateSidebar();
        await this.load();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.showDisabled !== prevState.showDisabled)
            this.updateSidebar();
    }

    updateSidebar = () => {
        SidebarGlobal.setSubNav(<>
            <button className="btn btn-primary" onClick={() => this.props.navigate('/workflow/new')}>
                <Icon icon="faPlus" />
                <span className="d-none d-md-inline"> New Workflow</span>
            </button>
            <button className="btn btn-secondary" onClick={() => this.toggleDisabled()}>
                <Icon icon={this.state.showDisabled ? 'faEyeSlash' : 'faEye'} />
                <span className="d-none d-md-inline"> {this.state.showDisabled ? 'Hide' : 'Show'} Disabled</span>
            </button>
        </>);
    }

    load = async (showDisabled) => {
        if(showDisabled === undefined) showDisabled = this.state.showDisabled;
        await this.fillListAsync('/api/workflow/list?showDisabled=' + (showDisabled ? 'true' : 'false'), 'list');
    }

    toggleDisabled = async () => {
        let showDisabled = !this.state.showDisabled;
        await this.load(showDisabled);
        this.setState({ showDisabled: showDisabled });
    }

    delete = (item) => {
        Pop.showConfirm(<>Are you sure you want to delete <strong>{item.name}</strong>?</>, 'Delete Workflow', async () => {
            try {
                let j = await qreq.postAsync('/api/workflow/delete', {id: item.id});
                if(j.errorCode === 0) {
                    this.success('Deleted!');
                    this.setState({ selected: null });
                    await this.load();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch(e) {
                this.unkownErrorCallback(e)
            }
        });
    }

    restore = (item) => {
        Pop.showConfirm(<>Are you sure you want to restore <strong>{item.name}</strong>?</>, 'Restore Workflow', async () => {
            try {
                let j = await qreq.postAsync('/api/workflow/restore', {id: item.id});
                if(j.errorCode === 0) {
                    this.success('Restored!');
                    this.setState({ selected: null });
                    await this.load();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch(e) {
                this.unkownErrorCallback(e)
            }
        });
    }

    render() {
        return (
            <div className="container-fluid">
                <h1>Workflows</h1>

                {this.state.selected && <Modal show={this.state.selected} onHide={() => this.setState({ selected: null })}>
                    <Modal.Header>
                        {this.state.selected.name}
                    </Modal.Header>
                    <Modal.Body>
                        <div className="d-grid gap-1">
                            {this.state.selected.isDisabled ? <button type="button" className="btn btn-primary" onClick={() => this.restore(this.state.selected)}>
                                <Icon icon="faTrashArrowUp" /> Restore
                            </button>
                            : <button type="button" className="btn btn-danger" onClick={() => this.delete(this.state.selected)}>
                                <Icon icon="faTrash" /> Delete
                            </button>}
                            <button type="button" className="btn btn-secondary" onClick={() => this.setState({ selected: null })}>
                                <Icon icon="faCancel" /> Close
                            </button>
                        </div>
                    </Modal.Body>
                    </Modal>}

                <DataTable
                    model="workflow"
                    columns={[
                        {
                            name: 'actions',
                            valueFunc: row => (<>
                                <Link to={`./${row.id}`} className="btn btn-primary">
                                    <Icon icon="faEye" />
                                </Link>
                                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ selected: row })}>
                                    &nbsp;<Icon icon="faEllipsisV" />&nbsp;
                                </button>
                            </>
                            ),
                            style: { maxWidth: '200px' }
                        },
                        {
                            name: 'name', title: 'Name', valueFunc: (row) =>
                                <Link to={`./${row.id}`}>{row.name}</Link>
                        },
                        { name: 'description', title: 'Description' },
                        { name: 'isDisabled', title: 'Status',
                            valueFunc: (row) => row.isDisabled ? <>Disabled</> : <>Active</>
                        } 
                    ]}
                    data={this.state.list || []}

                />
            </div>
        );
    }
}

export default withParamsAndNavigate(WorkflowList);